import script from "./channel.vue?vue&type=script&setup=true&lang=js"
export * from "./channel.vue?vue&type=script&setup=true&lang=js"

import "./channel.vue?vue&type=style&index=0&id=50bc6f1c&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bc6f1c"]])

export default __exports__